import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-583b0947"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "氏名", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item_value_text" }
const _hoisted_8 = { class: "profile_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "フリガナ", -1))
const _hoisted_10 = { class: "profile_item_value" }
const _hoisted_11 = { class: "profile_item_value_text" }
const _hoisted_12 = { class: "profile_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "性別", -1))
const _hoisted_14 = { class: "profile_item_value" }
const _hoisted_15 = { class: "profile_item_value_text" }
const _hoisted_16 = { class: "profile_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "生年月日", -1))
const _hoisted_18 = { class: "profile_item_value" }
const _hoisted_19 = { class: "profile_item_value_text" }
const _hoisted_20 = { class: "profile_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "携帯電話番号", -1))
const _hoisted_22 = { class: "profile_item_value" }
const _hoisted_23 = { class: "profile_item_value_text" }
const _hoisted_24 = { class: "profile_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "住所", -1))
const _hoisted_26 = { class: "profile_item_value" }
const _hoisted_27 = { class: "profile_item_value_text" }
const _hoisted_28 = { class: "profile_item_value_text" }
const _hoisted_29 = { class: "profile_item_value_text" }
const _hoisted_30 = { class: "profile_button_register" }
const _hoisted_31 = { class: "profile_button_modify" }

import { ref, computed, watchEffect } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import { stringToDate, ymdFormat } from '@/utils/dateFormat';
import { zipCode2Jp, telCellularAddHyphen } from '@/utils/stringfilter';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileConfirmView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const firstName = store.getters['userRegistration/firstName'];
const lastName = store.getters['userRegistration/lastName'];
const firstNameKana = store.getters['userRegistration/firstNameKana'];
const lastNameKana = store.getters['userRegistration/lastNameKana'];
const sex = store.getters['userRegistration/sex'] ? store.getters['userRegistration/sex'] : '';
const birthDate = store.getters['userRegistration/birthDate'] ? ymdFormat(stringToDate(store.getters['userRegistration/birthDate'])) : '';
const telCellular = telCellularAddHyphen(store.getters['userRegistration/telCellular']);
const zipCode = zipCode2Jp(store.getters['userRegistration/zipCode']);
const pref = store.getters['userRegistration/pref'];
const addr1 = store.getters['userRegistration/addr1'];
const addr2 = store.getters['userRegistration/addr2'];
const addr3 = store.getters['userRegistration/addr3'];

const isLoading = ref(false);

const isError = computed(() => {
  return (
    !firstName ||
    !lastName ||
    !firstNameKana ||
    !lastNameKana ||
    !sex ||
    !birthDate ||
    !telCellular ||
    !zipCode ||
    !pref ||
    !addr1 ||
    !addr2
  );
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e21', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e21' });
  }
};

watchEffect(() => {
  if (isError.value) {
    transitionPreviousPage();
  }
});

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('userRegistration/registBasicInfo');
    store.dispatch('toasts/appendTimeToast', { label: '基本情報を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e20', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n20' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '基本情報の更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(lastName)) + _toDisplayString(_unref(firstName)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(lastNameKana)) + _toDisplayString(_unref(firstNameKana)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(sex)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(birthDate)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(telCellular)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(zipCode)), 1),
        _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(pref)) + " " + _toDisplayString(_unref(addr1)) + _toDisplayString(_unref(addr2)), 1),
        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(addr3)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ]))
}
}

})